import { ActionType, IAgency, IClientCompany, IUser } from './model'
import { Action, Nullable } from '../model'
import createReducer from '../createReducer'

export interface AuthenticationReducerType {
  user: Nullable<IUser>
  agency: Nullable<IAgency>
  clientCompany: Nullable<IClientCompany>
}

const defaultState: AuthenticationReducerType = {
  user: null,
  agency: null,
  clientCompany: null,
}

export const authenticationReducer = createReducer<AuthenticationReducerType>(defaultState, {
  [ActionType.RESET_AUTH]() {
    return { ...defaultState }
  },
  [ActionType.SET_USER](state: AuthenticationReducerType, action: Action) {
    return { ...state, user: action.payload }
  },
  [ActionType.SET_AGENCY](state: AuthenticationReducerType, action: Action<IAgency>) {
    return { ...state, agency: action.payload, clientCompany: null }
  },
  [ActionType.SET_CLIENT_COMPANY](state: AuthenticationReducerType, action: Action<IClientCompany>) {
    return { ...state, clientCompany: action.payload, agency: null }
  },
})
